export default __webpack_public_path__ + "static/media/download.ac77f3b6.svg";